<template>
    <div style="background-color: #fff; border-top-right-radius: 25px; border-top-left-radius: 25px; display: flex; flex-direction: column;">
        <!-- <ModalHeader :newLoginForm="true" :isBackBtnHidden='true' title="로그인 / 회원가입"></ModalHeader> -->
        <div style=" flex: 1">
            <div style="padding: 20px; padding-bottom: 32px;">
                <div style="font-weight: 500; margin-bottom: 8px; margin-top: 40px; text-align: center;">
                    <div style="font-size: 32px; font-weight: 700; line-height: 46px;">사커하우</div>
                    <div style="line-height: 24px;">내가 알던 축구의 확장</div>
                </div>
                <div style="display: flex; gap: 12px; justify-content: center;">
                    <img style="width: 40px;" v-for="index in 6" :key="index" :src="require(`@/assets/login-ico-${index}.png`)" alt="">
                </div>
            </div>

            <div style="text-align: center;">
                <div style="text-align:center;">
                    <!-- <img :src="require('@/assets/kakao_login_btn.jpg')" style="vertical-align:top;width:250px; margin-top:10px;" @click="loginKaKao"> -->
                    <div @click="loginKaKao" class="login_btn_style" style="background-color:#FFDA3A; position: relative; color: #101014; font-size: 14px; margin-bottom: 12px; margin-top:5px;">
                        <img :src="require('@/assets/img/kakao_login.png')" style="width: 18px; position: absolute; top: 50%; transform: translateY(-50%); left: 20px;" alt="">
                        카카오로 로그인하기
                    </div>
                    <div v-if="is_show_social" @click="loginNaver" class="login_btn_style" style="background-color:#03CF5D; position: relative; color: white; font-size: 14px; margin-bottom: 12px; margin-top:5px;">
                        <img :src="require('@/assets/img/naver_login.png')" style="width: 18px; position: absolute; top: 50%; transform: translateY(-50%); left: 20px;" alt="">
                        네이버로 로그인하기
                    </div>
                    <div v-if="isIOS" @click="loginApple" class="login_btn_style" style="background-color:#101014; position: relative; font-size: 14px; margin-top: 0; margin-bottom:0px; ">
                        <img :src="require('@/assets/img/apple_login.png')" style="width: 18px; position: absolute; top: 50%; transform: translateY(-50%); left: 20px;" alt="">
                        애플로 로그인하기
                    </div>
                    <div v-if="is_show_social" @click="loginGoogle" class="login_btn_style" style="background-color:#F5F5F5; position: relative; color: #210F03; font-size: 14px; margin-bottom: 12px; margin-top:5px;">
                        <img :src="require('@/assets/img/google_login.png')" style="width: 18px; position: absolute; top: 50%; transform: translateY(-50%); left: 20px;" alt="">
                        구글 로그인하기
                    </div>
                    <!-- <div v-if="isIOS" style="display:inline-block;">
                        <div style="height:34px; width:250px; background-color: black; display:flex; justify-content: center; align-items: center; color:white; line-height:34px;border-radius:20px; margin-top: 10px;" @click="loginApple">
                            <img :src="require('@/assets/apple_icon.jpg')" style="height:22px;">
                            <div style=" margin-left:10px;">Apple로 로그인</div>
                        </div>
                    </div> -->
                    <!--<div v-if="isIOS" style="height:34px;overflow: hidden;margin-top: 10px;">-->
                    <!--<div style="display:inline-block;border-radius:17px; overflow:hidden;height: 34px;">-->
                    <!--<img :src="require('@/assets/apple_login_btn.png')" style="vertical-align:top;width:250px;margin-top: -7px;" @click="loginApple">-->
                    <!--</div>-->
                    <!--</div>-->
                </div>
            </div>

            <div style="padding: 0 20px; margin-bottom: 20px; margin-top:30px;">
                <div style="display: flex; justify-content: space-between; font-weight: 500; font-size: 14px; margin-bottom: 8px;">
                    <div>사커하우 계정</div>
                </div>
                <div>
                    <div style="position: relative; z-index: 10;" :style="{ borderBottom: isShowPasswordInput ? '1px solid #ebebeb' : '' }">
                        <input v-model="id" placeholder="이메일을 입력하세요" :class="isShowPasswordInput ? 'active_email' : ''" class="common_box" style="outline: none; width: 100%; border: none;">
                    </div>
                    <Transition name="fade">
                        <div v-if="isShowPasswordInput" style="transition: all 0.3s; position: relative; z-index: 1;">
                            <input type="password" v-model="password" placeholder="비밀번호를 입력하세요" :class="isShowPasswordInput ? 'active_password' : ''" class="common_box" style="outline: none; width: 100%; border: none;">
                        </div>
                    </Transition>
                </div>
            </div>
            <div style="position: relative; font-size: 14px; font-weight: 500; padding: 0 20px; margin-bottom: 40px;">
                <div class="common_box">
                    <div @click="showFindAccount" style="padding-bottom: 12px; border-bottom: 1px solid #dbdbdb;">전화번호로 계정 찾기</div>
                    <div @click="showMemberRegist" style="padding-top: 12px; color: var(--color-main);">새로운 사커하우 계정 만들기</div>
                    <div v-if="false" :class="showGuideBox ? 'guide_box' : 'guide_box_off'">
                        <div class="triangle" style=""></div>
                        <div @click="closeGuidePopup" style="display: flex; align-items: center; gap: 10px;">
                            <div style="flex-shrink: 0;">잠깐! 코치님이신가요?</div>
                            <div style="width: 20px; height: 20px; display: flex; align-items: center; justify-content: center;">
                                <img style="width: 12px;" :src="require('@/assets/img/guide_X.png')" alt="">
                            </div>
                        </div>
                        <div style="line-height: 18px; font-size: 12px;">코치님의 경우 사커하우 코치앱을 이용해주세요.</div>
                        <div @click="goCoachApp(); $Util.sendEventClick('공통_로그인_코치앱_더알아보기')" style="height: 35px; line-height: 35px; border-radius: 22.5px; background-color: #fff; color: #000; text-align: center; font-size: 12px;">더 알아보기</div>
                    </div>
                </div>
                <div style="display:flex; flex-direction: row-reverse; padding-top:14px;">
                    <div v-if="!isShowPasswordInput" @click="nextStep" style="display: flex; align-items: center; gap: 4px;">
                        <div :class="id.length === 0 ? 'unactive_next' : 'active_next'">다음</div>
                        <img style="width: 8px;" :src="id.length === 0 ? require('@/assets/img/arrow_tick.png') : require('@/assets/img/arrow_tick_active.png')" alt="">
                    </div>
                    <div v-else @click="login" style="display: flex; align-items: center; gap: 4px;">
                        <div :class="password.length !== 0 ? 'active_next' : 'unactive_next'">로그인</div>
                        <img style="width: 8px;" :src="password.length === 0 ? require('@/assets/img/arrow_tick.png') : require('@/assets/img/arrow_tick_active.png')" alt="">
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
import { LOGIN_PLATFORM } from "../../Constants";

export default {
    name: "Login",
    components: {},
    props: {
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    computed: {
        isIOS() {
            const device = this.$cookies.get('device');
            return device === 'ios';
        }
    },
    data() {
        return {
            id: '',
            password: '',
            showGuideBox: false,
            isShowPasswordInput: false,
            is_show_social: false,
        }
    },
    methods: {
        nextStep() {
            if (this.id.length === 0) {
                alert('아이디를 입력해주세요.');
                return;
            }
            this.isShowPasswordInput = !this.isShowPasswordInput
        },
        closeGuidePopup() {
            this.showGuideBox = false
        },
        async login() {
            const parameters = {};
            parameters.id = this.id;
            parameters.password = this.password;
            const device = this.$cookies.get('device');
            if (device === 'android' || device === 'ios') {
                parameters.pushToken = await window.pushCustomManager.getPushToken();
                parameters.uuid = await window.pushCustomManager.getUuid();
            }

            parameters.marketingAgree = localStorage.getItem('marketing_agree') ?? '';

            const res = await this.$Axios.post('/api/login', parameters);
            let isOpenChatWritten

            if (res.data.code === 0) {
                localStorage.removeItem('marketing_agree');
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.$GlobalStore.closeLastModal(true);
                isOpenChatWritten = await this.$Axios.get('/api/chat/check/opentalk/contents/exist')

                await this.$Util.checkAfterLogin(res.data.isSoccerhowWritten, res.data.loginInfo, isOpenChatWritten.data.is_opentalk_written)
            } else {
                alert(res.data.msg);
            }

        },
        showMemberRegist() {
            this.$GlobalStore.addModal('MemberTypeSelect', {
                isModalBackTransparent: true, transitionName: 'bottom', completeAction: (register_type) => {
                    this.$GlobalStore.addModal('MemberRegist', { transitionName: 'bottom', register_type: register_type });
                }
            })
        },
        async loginKaKao() {
            const device = this.$cookies.get('device');

            if (device === 'android') {
                this.$GlobalStore.addModal('KaKaoLogin', { transitionName: '' });
            } else if (device === 'ios') {
                // const isInstalled = await KaKaoLoginManager.getKaKaoInstalled();
                // if(isInstalled){
                this.$GlobalStore.addModal('KaKaoLogin', { transitionName: '' });
                // }else {
                //     this.$GlobalStore.showAlert('카카오 로그인은 카카오톡 설치가 필요합니다.');
                // }
            } else {
                // const userAgent = navigator.userAgent;
                // if (userAgent.match(/iPhone|iPad|iPod|KAKAOTALK/i)) {
                window.open('http://192.168.0.24:8053/login/kakao/form')
                // }else {
                //     this.$GlobalStore.addModal('KaKaoLogin', { transitionName: '' });
                // }
            }

        },
        async loginNaver() {
            const device = this.$cookies.get('device');
            let pushToken = '';
            let uuid = '';
            if (device === 'android' || device === 'ios') {
                pushToken = await window.pushCustomManager.getPushToken();
                uuid = await window.pushCustomManager.getUuid();
            }

            const query = "?pushToken=" + pushToken + '&uuid=' + uuid;

            let domain = '';
            //TODO 테스트 할때만 주석풀어서 사용.
            // domain = 'http://192.168.0.203:8060';

            if (device === 'ios') {
                const url = (domain ? domain : location.origin) + "/login/naver/form" + query;

                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'showWebView', url: url });
            } else {
                const url = domain + "/login/naver/form" + query;
                window.open(url);
            }
        },
        async loginGoogle() {
            const device = this.$cookies.get('device');
            let pushToken = '';
            let uuid = '';
            if (device === 'android' || device === 'ios') {
                pushToken = await window.pushCustomManager.getPushToken();
                uuid = await window.pushCustomManager.getUuid();
            }

            const query = "?pushToken=" + pushToken + '&uuid=' + uuid;

            let domain = '';
            //TODO 테스트 할때만 주석풀어서 사용.
            // domain = 'http://ubiplus.iptime.org:8001';

            if (device === 'ios') {
                const url = (domain ? domain : location.origin) + "/login/google/form" + query;

                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'showWebView', url: url });
            } else {
                const url = domain + "/login/google/form" + query;
                window.open(url);
            }
        },
        async loginApple() {
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({ cmd: 'loginApple' });
        },
        showFindAccount() {
            this.$GlobalStore.addModal('FindAccount', { transitionName: 'bottom', isModalBackTransparent: true });
        },
        goCoachApp() {
            let url = '';
            const device = this.$cookies.get('device');
            if (device === 'android') {
                url = 'market://details?id=com.ubiplus.custom.obyungear_coach';
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                url = 'itms-apps://itunes.apple.com/app/6443950748';
            }
            this.$Util.showBrowser(url);
        }
    },
    created() {
        this.login = this.$Once(this.login)
        const is_show_social = this.$cookies.get('is_show_social');

        if (is_show_social === '1') {
            const device = this.$cookies.get('device');
            if (device === 'android' || device === 'ios') {
                const app_version = this.$cookies.get('appv');
                if (!app_version) return;

                let is_apply = false;

                if (device === 'ios') {
                    is_apply = parseInt(app_version) >= 26;
                } else if (device === 'android') {
                    is_apply = parseInt(app_version) >= 17;
                }

                if (is_apply) this.is_show_social = true;
            } else {
                this.is_show_social = true;
            }
        }

        window.loginApple = async (id) => {
            const parameters = {};
            parameters.id = id;

            const device = this.$cookies.get('device');
            if (device === 'android' || device === 'ios') {
                parameters.pushToken = await window.pushCustomManager.getPushToken();
                parameters.uuid = await window.pushCustomManager.getUuid();
            }

            parameters.marketingAgree = localStorage.getItem('marketing_agree') ?? '';

            const res = await this.$Axios.post('/login/apple', parameters);
            if (res.data.code === 0) {
                localStorage.removeItem('marketing_agree');
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.$GlobalStore.closeLastModal(true);

                await this.$Util.checkAfterLogin(res.data.isSoccerhowWritten);

            } else if (res.data.code === 1) {
                this.$GlobalStore.addModal('KaKaoRegist', { id: id, mode: LOGIN_PLATFORM.APPLE });
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        }
        setTimeout(() => {
            this.showGuideBox = true
        }, 1000);
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}

.guide_box {
    width: 195px;
    height: 160px;
    display: flex;
    flex-direction: column;
    top: 95px;
    justify-content: space-between;
    padding: 18px;
    color: #fff;
    border-radius: 10px;
    background: #0A0D14CC;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    opacity: 1;
    transition: all 0.5s;
    box-shadow: 0px 5px 9.899999618530273px 0px #10101426;

}

.guide_box_off {
    width: 195px;
    height: 160px;
    display: flex;
    flex-direction: column;
    top: 95px;
    justify-content: space-between;
    padding: 18px;
    color: #fff;
    border-radius: 10px;
    background: #0A0D14CC;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    opacity: 0;
    transition: all 0.5s;
    visibility: hidden;
}

.triangle {
    border-top: 0px solid transparent;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid #393c41;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    content: "";
    position: absolute;
    top: -14px;
    left: 50%;
    transform: translateX(-50%);
}

.label_wrap {
    padding: 0px 15px;
    margin-top: 20px;
}

.label {
    font-size: 14px;
    font-weight: bold;
    color: #505050;
}

.content_wrap {
    margin-top: 5px;
}

.input_contents {
    padding: 10px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid #aaaaaa;
}

.input_contents::placeholder {
    font-size: 14px;
    color: #aaaaaa;
}

.input_style {
    width: 100%;
    border: 1px solid #d9d9d9;
    margin: 0;
    border-radius: 0;
    padding: 13px;
    outline: none;
}

.login_btn_style {
    margin: 20px;
    font-weight: 500;
    height: 39px;
    line-height: 39px;
    color: #fff;
    border-radius: 12px;
    width: calc(100% - 40px);
    text-align: center;
}

.common_box {
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 12px;
}

input::placeholder {
    font-weight: 500;
    font-size: 16px;
    color: #bbbbbb;
}

.active_email {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0
}

.active_password {
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.active_next {
    color: var(--color-main);
}

.unactive_next {
    color: #d9d9d9;
}

.fade-enter-active {
    animation: show 0.3s;
}


@keyframes show {
    0% {
        transform: translateY(-100%)
    }

    100% {
        transform: translateY(0);
    }
}
</style>
